import React, { useEffect, useRef } from 'react';

function getActiveSegmentIndex(segments, currentTimeMs) {
  if (!segments || segments.length === 0) return -1;
  for (let i = segments.length - 1; i >= 0; i--) {
    const seg = segments[i];
    if (currentTimeMs >= (seg.start_ms || 0) && currentTimeMs <= (seg.end_ms || Infinity)) {
      return i;
    }
  }
  // If no exact match, find last segment whose start_ms <= currentTimeMs
  for (let i = segments.length - 1; i >= 0; i--) {
    if (currentTimeMs >= (segments[i].start_ms || 0)) return i;
  }
  return -1;
}

export default function InteractiveTranscript({ segments, currentTimeMs, onSeek }) {
  const activeIndex = getActiveSegmentIndex(segments, currentTimeMs);
  const activeRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [activeIndex]);

  if (!segments || segments.length === 0) {
    return (
      <div style={{ padding: '16px', color: '#64748b', fontSize: 13 }}>
        No transcript available.
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      role="region"
      aria-label="Interactive transcript"
      style={{
        overflowY: 'auto',
        maxHeight: 320,
        padding: '8px 0',
      }}
    >
      {segments.map((seg, i) => {
        const isActive = i === activeIndex;
        return (
          <button
            key={i}
            ref={isActive ? activeRef : null}
            onClick={() => onSeek(seg.start_ms || 0)}
            style={{
              display: 'block',
              width: '100%',
              textAlign: 'left',
              background: isActive ? 'rgba(59,130,246,0.12)' : 'transparent',
              border: 'none',
              borderLeft: isActive ? '3px solid #3b82f6' : '3px solid transparent',
              borderRadius: 0,
              padding: '6px 14px 6px 10px',
              cursor: 'pointer',
              color: isActive ? '#1f2937' : '#6b7280',
              fontSize: 14,
              lineHeight: 1.5,
              transition: 'background 0.15s, color 0.15s',
              fontWeight: isActive ? 500 : 400,
            }}
          >
            {seg.text}
          </button>
        );
      })}
    </div>
  );
}
